
<template>
    <v-layout style="position: relative; min-height: 200px;" align-center justify-center>
        <loading v-if="loadingDepartmentCodes"></loading>  
        <v-flex v-else>
            <v-layout wrap>
                <v-flex xs12 sm2>
                    <v-btn right class="primary mx-4"  @click="addDepartmentCode()">Add Department Code</v-btn>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex xs12 sm3>
                    <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                </v-flex>
            </v-layout>
            <v-data-table :headers="headers" :items="departmentCodes" :pagination.sync="pagination" hide-actions :search="search" :no-results-text="noSearchResults" >
                <template v-slot:items="props">
                    <td>{{ props.item.ActivityDepartmentCode }}</td>
                    <td>{{ props.item.Description }}</td>
                    <td>
                        <span v-for="(productCategory, index) in props.item.ProductCategories" :key="index">{{ nameWithComma(index, 'ProductCategoryName' , props.item.ProductCategories) }} </span>
                    </td>
                    <td>
                        <span v-for="(division, index) in props.item.Divisions" :key="index">{{ nameWithComma(index, 'DivisionName' , props.item.Divisions) }} </span>
                    </td>
                    <td>
                        <v-btn right class="primary" @click="editDepartmentCode(props.item)">Edit</v-btn>
                    </td>
                </template>
            </v-data-table>
            
            <v-dialog :value="showEditDepartmentCode" max-width="500px" persistent @keydown.esc="handleCloseEdit()">
                <crop-work-department-code-edit v-if="showEditDepartmentCode" :editData="targetDepartmentCode" @close="handleCloseEdit()">
                </crop-work-department-code-edit>
            </v-dialog>
            <!-- <no-data v-if="!cropProfile.CropArea" message="No Activity Department Codes defined."></no-data> -->
        </v-flex>
    </v-layout>
</template>

<script>
import Loading from '@/components/generic/Loading.vue';
import CropWorkDepartmentCodeEdit from '@/components/cropwork/EditDepartmentCode.vue';

// import UtilService from '@/services/utilService.js';
// import moment from 'moment';

import {
    mapState
} from 'vuex';

export default {
    components: {
        Loading,
        CropWorkDepartmentCodeEdit,
    },
    props: [    
        'loading',
        'plantID'
    ],
    data(){
        return {    
            showEditDepartmentCode: false,
            targetDepartmentCode: null,
            search: "",
            pagination: {
                rowsPerPage: -1
            }
        };
    },
    computed: {
        ...mapState("CropWorkStore", [
            "departmentCodes",
            "loadingDepartmentCodes",
        ]),
        headers() {
            return  [
                { text: 'Activity Department Code', value: 'ActivityDepartmentCode'},
                { text: 'Description', value: 'Description' },
                { text: 'Product Categories', value: 'ProductCategory', sortable: false },
                { text: 'Divisions', value: 'Division', sortable: false },
                { text: 'Edit', value: 'Edit', sortable: false }
            ]
        },
        noSearchResults() {
            return "Your search for \""+ this.search + "\" returned no results."
        }
    },
    methods: {
        nameWithComma(index, nameKey, list) {
            if(index != list.length - 1){
                return `${list[index][nameKey]},`
            }
            return `${list[index][nameKey]}`
        },
        addDepartmentCode() {
            this.showEditDepartmentCode = true;
            this.targetDepartmentCode = {
                CropWorkDepartmentCodeID:-1,
                ProductCategoryID:-1,
                ActivityDepartmentCode:"",
                Description: "",
                PlantID: this.plantID,
                Divisions:[]
            }
        },
        editDepartmentCode(item) {
            this.showEditDepartmentCode = true;
            this.targetDepartmentCode = Object.assign({}, item)
        },
        handleCloseEdit() {
            this.showEditDepartmentCode = false;
            this.targetDepartmentCode = null;
        }
    }
}
</script>